var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scroll-to-anchor",attrs:{"type":"button","aria-hidden":"true"},on:{"click":_vm.onScrollClick}},[_c('font-awesome-icon',{attrs:{"icon":"caret-down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }